module.exports = __webpack_public_path__ + "img/dk.20d07a53.png";